module.exports = __webpack_public_path__ + "img/boming.590453e5.svg";